import Config from '../config';

import {TeamResponse} from "./responses";
import {
    CouldNotCreateTeamError,
    CouldNotFindTeamError,
    TimerAlreadyRunningError
} from "./errors";
import StartTimerResponse from "./responses/StartTimerResponse";
import CouldNotStartTimerError from "./errors/CouldNotStartTimerError";

export interface ITimerMessage {
    type:string;
    name:string;
    team:string;
    remaining:number;
};

export interface ITimerSettings extends ITimerMessage {
    settings:object
}

export interface ILink {
    link: string;
    rel: string;
    type: string;
}

const baseUrl: string = Config.apiUrl;

export const createTeam = async (team: string):Promise<TeamResponse> => {
    const url = `${baseUrl}/team`;

    const options = {
        body: JSON.stringify({team}),
        method: 'POST'
    };

    try {
        const response = await fetch(url, options);
        const json = await response.json();
        switch(response.status) {
            case 409: // HTTP 409 Conflict
                return Promise.reject(new CouldNotCreateTeamError(json, team));
            case 201: // HTTP 201 Created
            case 200: // HTTP 200 Created
            case 303: // HTTP 303 Created
                return fetchTeam(json.slug);
            default:
                return Promise.reject(new Error("Unknown error"));
        }
    } catch (e) {
        return Promise.reject(new Error("Unknown error"));
    }
};

export const fetchTeam = async (team: string):Promise<TeamResponse> => {
    const url = `${baseUrl}/team/${team}`;

    try {
        const response = await fetch(url);

        const json = await response.json()

        switch(response.status) {
            case 404:
                return Promise.reject(new CouldNotFindTeamError(json.error, team));
            case 200:
                return new TeamResponse(json);
        }
    } catch (e) {
        return Promise.reject(new Error("Unknown error"));
    }

    return Promise.reject(new Error("Unknown error"));
};

export const startTimer = async (team: string, duration: number, name: string): Promise<StartTimerResponse> => {
    const url = `${baseUrl}/team/${team}/timer/start`;

    const request = {duration, name};
    const options = {
        body: JSON.stringify(request),
        method: 'PUT',
    };

    try {
        const response = await fetch(url, options);
        const json = await response.json();

        switch(response.status) {
            case 500:
                return Promise.reject(new CouldNotStartTimerError(json.error, team));
            case 404:
                return Promise.reject(new CouldNotFindTeamError(json.error, team));
            case 409:
                return Promise.reject(new TimerAlreadyRunningError(json.error, team));
            case 201:
                return new StartTimerResponse(json);
        }
    } catch(e) {
        return Promise.reject(new Error("Unknown error"));
    }

    return Promise.reject(new Error("Unknown error"));
};

export const stopTimer = async (team: string): Promise<boolean> => {
    const url = `${baseUrl}/team/${team}/timer`;

    const options = {
        method: 'DELETE'
    };

    const response = await fetch(url, options);
    const json = await response.json();

    if(response.status === 500) {
        return new Promise<boolean>((resolve, reject) => reject(json));
    }

    return true;

};

export const saveSettings = async (team:string, settings:any):Promise<ITimerSettings> => {
    const url = `${baseUrl}/team/${team}/settings`;

    const options = {
        body: JSON.stringify({focus: settings.focus, pause: settings.pause}),
        method: 'POST'
    };

    const response = await fetch(url, options );
    const json = await response.json();

    return (json as any) as ITimerSettings;
};




// WEBPACK FOOTER //
// ./src/api/Api.ts